// extracted by mini-css-extract-plugin
module.exports = {"body":"Drawer_body__WvEa_","content":"Drawer_content__J1sAk","header":"Drawer_header__pHhFr"};